import { Segment } from '@fixter/i18n';

export function getLinksListTitle(sectionName: string, segment?: Segment): string | undefined {
  const frSegment = segment === Segment.Fixter_FR;

  switch (sectionName) {
    case 'product':
      return frSegment ? 'Services populaires' : 'Popular services';
    case 'area':
      return frSegment ? 'Emplacements populaires' : 'Popular locations';
    case 'carMake':
      return frSegment ? 'Trouvez votre marque de voiture' : 'Find your car make';
    case 'carModel':
      return frSegment ? 'Trouvez votre modèle de voiture' : 'Find your car model';
    default:
      return undefined;
  }
}
